module.exports = __webpack_public_path__ + "img/п.3.fb7aef60.png";